import {
  AcademicCapIcon,
  ArrowTopRightOnSquareIcon,
  CodeBracketIcon,
} from "@heroicons/react/24/outline";
import React from "react";

import { DemoPage } from "utils/demoGuide";

interface DemoGuideCardProps {
  onOpen: (page: DemoPage) => void;
  /** Whether we have an API key to sign the customer in to the demo with. */
  hasApiKey: boolean;
}

const DemoGuideCard: React.FC<DemoGuideCardProps> = ({ onOpen, hasApiKey }) => (
  <div className="flex flex-col gap-4 rounded-md border border-indigo-200 bg-gradient-to-r from-indigo-50 to-white p-5 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:p-6">
    <div className="flex items-start gap-3">
      <span className="flex-shrink-0 rounded-lg bg-indigo-100 p-2 text-indigo-700">
        <AcademicCapIcon className="h-6 w-6" />
      </span>
      <div className="min-w-0">
        <h3 className="text-lg font-semibold text-gray-900">
          Interactive demo &amp; API guide
        </h3>
        <p className="mt-1 max-w-2xl text-sm leading-relaxed text-gray-600">
          Take a guided tour of the product and learn the API hands-on, already
          signed in with your API key.
        </p>
        {!hasApiKey && (
          <p className="mt-1 text-sm text-amber-700">
            Create an active API key below to open the demo signed in.
          </p>
        )}
      </div>
    </div>
    <div className="flex flex-shrink-0 flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onOpen("/tour")}
        disabled={!hasApiKey}
        className="inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60"
      >
        Open the demo
        <ArrowTopRightOnSquareIcon className="h-4 w-4 opacity-70" />
      </button>
      <button
        type="button"
        onClick={() => onOpen("/developers")}
        disabled={!hasApiKey}
        className="inline-flex items-center gap-2 rounded-lg border border-indigo-300 bg-white px-4 py-2.5 text-sm font-semibold text-indigo-700 shadow-sm transition-colors hover:bg-indigo-50 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <CodeBracketIcon className="h-4 w-4" />
        API guide
      </button>
    </div>
  </div>
);

export default DemoGuideCard;
